<template>
  <div>
    <div class="cards_box">
      <el-card shadow="hover" class="mgb20 card">
        <div>平台总用户</div>
        <div class="card-number">{{ value.totalUserNum }}</div>
      </el-card>
      <el-card shadow="hover" class="mgb20 card">
        <div>今日已发布数量</div>
        <div class="card-number">{{ value.todayPublishNumber }}</div>
      </el-card>
      <el-card shadow="hover" class="mgb20 card">
        <div>今日领取人数</div>
        <div class="card-number">{{ value.todayReceiveNumber }}</div>
      </el-card>
      <el-card shadow="hover" class="mgb20 card">
        <div>
          昨日已发布数量
          <div class="card-number">{{ value.yesterdayPublishNumber }}</div>
        </div>
      </el-card>
      <el-card shadow="hover" class="mgb20 card">
        <div>
          昨日领取人数
          <div class="card-number">{{ value.yesterdayReceiveNumber }}</div>
        </div>
      </el-card>
    </div>
    <!--      <el-col :span="8">
        <el-card shadow="hover" class="mgb20 card">
          <div>
            累计充值金额
            <div class="card-number">{{ value.totalRechargeMoney }}USDT</div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="8">
        <el-card shadow="hover" class="mgb20 card">
          <div>
            累计提现金额
            <div class="card-number">{{ value.totalWithdrawMoney }}USDT</div>
          </div>
        </el-card>
      </el-col>-->
    <!--    <el-row :gutter="20">
      <el-col :span="8">
        <el-card shadow="hover" class="mgb20 card">
          <div>今日注册人数</div>
          <div class="card-number">{{ value.todayRegister }}</div>
        </el-card>
      </el-col>
      <el-col :span="8">
        <el-card shadow="hover" class="mgb20 card">
          <div>昨日注册人数</div>
          <div class="card-number">{{ value.yesterdayRegister }}</div>
        </el-card>
      </el-col>
      <el-col :span="8">
        <el-card shadow="hover" class="mgb20 card">
          <div>
            今日充值金额
            <div class="card-number">{{ value.todayRechargeMoney }}USDT</div>
          </div>
        </el-card>
      </el-col>
    </el-row>-->
    <!--    <el-row :gutter="20">
      <el-col :span="8">
        <el-card shadow="hover" class="mgb20 card">
          <div>
            今日充值笔数
            <div class="card-number">{{ value.todayRechargeNum }}</div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="8">
        <el-card shadow="hover" class="mgb20 card">
          <div>
            今日充值人数
            <div class="card-number">{{ value.todayRechargeUserNum }}</div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="8">
        <el-card shadow="hover" class="mgb20 card">
          <div>
            今日提现金额
            <div class="card-number">{{ value.todayWithdrawMoney }}USDT</div>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="8">
        <el-card shadow="hover" class="mgb20 card">
          <div>
            今日提现笔数
            <div class="card-number">{{ value.todayWithdrawNum }}</div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="8">
        <el-card shadow="hover" class="mgb20 card">
          <div>
            今日提现人数
            <div class="card-number">{{ value.todayWithdrawUserNum }}</div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="8">
        <el-card shadow="hover" class="mgb20 card">
          <div>
            昨日充值金额
            <div class="card-number">
              {{ value.yesterdayRechargeMoney }}USDT
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>-->

    <!--    <el-row :gutter="20">
      <el-col :span="8">
        <el-card shadow="hover" class="mgb20 card">
          <div>
            昨日充值笔数
            <div class="card-number">{{ value.yesterdayRechargeNum }}</div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="8">
        <el-card shadow="hover" class="mgb20 card">
          <div>
            昨日充值人数
            <div class="card-number">{{ value.yesterdayRechargeUserNum }}</div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="8">
        <el-card shadow="hover" class="mgb20 card">
          <div>
            昨日提现金额
            <div class="card-number">
              {{ value.yesterdayWithdrawMoney }}USDT
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="8">
        <el-card shadow="hover" class="mgb20 card">
          <div>
            昨日提现笔数
            <div class="card-number">{{ value.yesterdayWithdrawNum }}</div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="8">
        <el-card shadow="hover" class="mgb20 card">
          <div>
            昨日提现人数
            <div class="card-number">{{ value.yesterdayWithdrawUserNum }}</div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="8">
        <el-card shadow="hover" class="mgb20 card">
          <div>
            今日首充人数
            <div class="card-number">{{ value.todayFirstChargeNum }}</div>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="8">
        <el-card shadow="hover" class="mgb20 card">
          <div>
            今日首充金额
            <div class="card-number">{{ value.todayFirstChargeMoney }}USDT</div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="8">
        <el-card shadow="hover" class="mgb20 card">
          <div>
            昨日首充金额
            <div class="card-number">
              {{ value.yesterdayFirstChargeMoney }}USDT
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>-->
  </div>
</template>

<script>
export default {
  name: 'Home',
  data() {
    return {
      value: {
        /** 总用户 */
        totalUserNum: 0,

        /** 今日注册数 */
        todayRegister: 0,

        /** 今日充值金额 */
        todayRechargeMoney: 0,

        /** 今日充值笔数 */
        todayRechargeNum: 0,

        /** 今日充值人数 */
        todayRechargeUserNum: 0,

        /** 今日提现金额 */
        todayWithdrawMoney: 0,

        /** 今日提现人数 */
        todayWithdrawUserNum: 0,

        /** 今日首充人数 */
        todayFirstChargeNum: 0,

        /** 今日首充金额 */
        todayFirstChargeMoney: 0,

        /**
         * todayReceiveNumber
         */
        todayReceiveNumber: 0,

        /**
         * 今日发布数量
         */
        todayPublishNumber: 0,

        /** 昨日注册数 */
        yesterdayRegister: 0,

        /** 昨日充值金额 */
        yesterdayRechargeMoney: 0,

        /** 昨日充值笔数 */
        yesterdayRechargeNum: 0,

        /** 昨日充值人数 */
        yesterdayRechargeUserNum: 0,

        /** 昨日提现金额 */
        yesterdayWithdrawMoney: 0,

        /** 昨日提现人数 */
        yesterdayWithdrawUserNum: 0,

        /** 昨日提现笔数 */
        yesterdayWithdrawNum: 0,

        /** 昨日首充金额 */
        yesterdayFirstChargeMoney: 0,

        /** 总提现充值 */
        totalRechargeMoney: 0,
        /** 总提现金额 */
        totalWithdrawMoney: 0,

        /**
         * 昨日领取人数
         */
        yesterdayReceiveNumber: 0,

        /**
         * 昨日发布数量
         */
        yesterdayPublishNumber: 0

      },
      show: true,
    }
  },
  activated() {
    this.getHomeData()
  },
  methods: {
    getHomeData() {
      this.$axios.post({
        url: '/system/home',
        success: (res) => {
          if (res.code === 0) {
            if (res.data) {
              this.value = res.data
              this.show = true
            } else {
              this.show = false
            }
            return
          }
          this.$message.error(res.msg)
        },
      })
    },
  },
}
</script>

<style scoped>
.mgb20 {
  margin-bottom: 20px;
}

.cards_box {
  display: flex;
  /* justify-content: space-between; */
  flex-wrap: wrap;
}

.card {
  min-height: 100px;
  font-size: 20px;
  font-weight: 600;
  padding-bottom: 20px;
  margin-right: 20px;
  width: 32%;
}

.card-number {
  padding-top: 20px;
  font-size: 30px;
  line-height: 38px;
}



@media (max-width: 768px) {
  .card {
    width: auto;
    min-width: 90%;

  }

}
</style>
